function MorphButton(el) {
    this.el = el;

    this.initialPath = MorphSVGPlugin.convertToPath(this.el.querySelector('.jsInitialPath'));

    this.firstCircleElPath = MorphSVGPlugin.convertToPath(this.el.querySelector('.jsFirstCircle'));
    this.secondCircleElPath = MorphSVGPlugin.convertToPath(this.el.querySelector('.jsSecondCircle'));
    
    this.firstStroke = this.el.querySelector('.jsFirstStroke');
    this.secondStroke = this.el.querySelector('.jsSecondStroke');

    this.animationDuration = 4;

    this.timeline = gsap.timeline({ repeat: -1 })
        .set(this.firstCircleElPath, { morphSVG: this.secondStroke, transformOrigin: '50% 50%' })
        .set(this.secondCircleElPath, { morphSVG: this.firstStroke, transformOrigin: '50% 50%' })

        .to(this.firstCircleElPath, this.animationDuration, { morphSVG: this.firstStroke, ease: Power0.easeNone })
        .to(this.secondCircleElPath, this.animationDuration, { morphSVG: this.secondStroke, scale: 0.95, ease: Power0.easeNone }, '-=' + (this.animationDuration - 0.3))

        .to(this.firstCircleElPath, this.animationDuration, { morphSVG: this.secondStroke, ease: Power0.easeNone })
        .to(this.secondCircleElPath, this.animationDuration, { morphSVG: this.firstStroke, scale: 1, ease: Power0.easeNone }, '-=' + (this.animationDuration - 0.3))
    ;

    if (this.el.classList.contains('jsButtonMorph-paused')) {
        this.timeline.pause();

        gsap.set(this.firstCircleElPath, { morphSVG: { shape: this.secondStroke } });
        gsap.set(this.secondCircleElPath, { morphSVG: { shape: this.firstStroke } });

        this.el.addEventListener('mouseover', _ => this.timeline.play());
        this.el.addEventListener('mouseout', _ => this.timeline.reverse());
    }
}

(function() {
    const btnEls = document.querySelectorAll('.jsButtonMorph');
    btnEls.forEach(el => new MorphButton(el));
})();
